// extracted by mini-css-extract-plugin
export var contrastLow = "_24-1";
export var externalLink = "_24-2";
export var externalLinkIcon = "_24-3";
export var link = "_24-0";
export var linkLabel = "_24-4";